import React from 'react';

/**
 * Multi-line textarea field.
 *
 * Usage with react-hook-form:
 *   <TextareaField label="Description" id="description" rows={3}
 *     register={register("description")}
 *     error={errors.description}
 *     placeholder="Enter description..." />
 *
 * Usage controlled:
 *   <TextareaField label="Notes" rows={3} value={notes}
 *     onChange={e => setNotes(e.target.value)}
 *     hint="These notes will be included in the email." />
 */

const FULL_CLS =
  'block w-full rounded-2xl border-0 py-2.5 px-4 text-gray-900 shadow-sm ring-1 ring-inset placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-green-600 sm:text-sm sm:leading-6';

export function TextareaField({
  label,
  id,
  register,
  error,
  rows = 3,
  placeholder,
  disabled,
  hint,
  className = '',
  labelClassName = '',
  wrapperClassName = '',
  ...rest  // value, onChange, etc.
}) {
  const ring = error ? 'ring-red-500' : 'ring-gray-300';
  const dis = disabled ? 'bg-gray-100 cursor-not-allowed text-gray-500' : '';

  return (
    <div className={wrapperClassName || 'w-full'}>
      {label && (
        <label
          htmlFor={id}
          className={`block text-sm font-medium text-gray-700 mb-1 ${labelClassName}`}
        >
          {label}
        </label>
      )}
      <textarea
        id={id}
        rows={rows}
        {...(register || {})}
        placeholder={placeholder}
        disabled={disabled}
        className={[FULL_CLS, ring, dis, className].filter(Boolean).join(' ')}
        {...rest}
      />
      {error && (
        <p className="mt-1 text-xs text-red-500">{error.message}</p>
      )}
      {hint && !error && (
        <p className="mt-1 text-xs text-gray-500">{hint}</p>
      )}
    </div>
  );
}
